import { HelpCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

/**
 * "O que o North IA sabe fazer" — as tools do chat (definidas em
 * db/supabase/functions/chat-ai/index.ts, geminiToolDeclarations, e as da
 * carteira pessoal em chat-ai/carteira.ts) têm
 * descrição escrita PRA MODELO, cheia de jargão de desambiguação ("PREFIRA
 * esta tool para...", nomes de parâmetro). Aqui elas viram 6 grupos em
 * português de gente, cada um com um exemplo clicável — clicar já preenche o
 * campo de mensagem, não precisa digitar do zero.
 */
type Capacidade = {
  titulo: string;
  descricao: string;
  exemplo: string;
};

const CAPACIDADES: Capacidade[] = [
  {
    titulo: "Prioridades do dia",
    descricao: "Contatos do dia e mudanças na carteira desde ontem.",
    exemplo: "Quem eu preciso contatar hoje?",
  },
  {
    titulo: "Carteira",
    descricao: "Vendas, leads, inadimplência e objetivo do mês.",
    exemplo: "Quanto falta para o meu objetivo do mês?",
  },
  {
    titulo: "Inadimplência",
    descricao: "Clientes em atraso na carteira.",
    exemplo: "Quem está inadimplente agora?",
  },
  {
    titulo: "Campanhas",
    descricao: "Campanhas de incentivo vigentes e o que falta para o próximo degrau.",
    exemplo: "Quais campanhas estão valendo?",
  },
  {
    titulo: "Estratégia de lance",
    descricao: "Valor da oferta, comparação entre grupos e histórico de contemplação.",
    exemplo: "Quanto devo ofertar de lance no grupo 1234?",
  },
  {
    titulo: "Simulação de consórcio",
    descricao: "Simulação, comparação de opções e grupo adequado ao objetivo do cliente.",
    exemplo: "Simule um consórcio de imóvel de R$300 mil em 200 meses.",
  },
  {
    titulo: "Projeto com várias cotas e financiamento",
    descricao: "Projeto com cotas combinadas ou comparação com financiamento bancário.",
    exemplo: "Monte um projeto de R$500 mil combinando cotas.",
  },
  {
    titulo: "Consórcio × financiamento",
    descricao: "Comparação com o financiamento no caso do cliente, com link da apresentação.",
    exemplo: "Para a proposta da Maria, o consórcio é melhor que o financiamento?",
  },
  {
    titulo: "Proposta em PDF",
    descricao: "Documento pronto para envio ao cliente.",
    exemplo: "Gere a proposta em PDF.",
  },
];

export const AjudaNorthIA = ({
  open,
  onClose,
  onUsarExemplo,
}: {
  open: boolean;
  onClose: () => void;
  onUsarExemplo: (texto: string) => void;
}) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <DialogContent className="max-w-[calc(100%-1.5rem)] sm:max-w-lg max-h-[85dvh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <HelpCircle className="h-5 w-5" />
          Recursos do North IA
        </DialogTitle>
        <DialogDescription>Selecione um exemplo para preencher a mensagem.</DialogDescription>
      </DialogHeader>
      <div className="space-y-3 pt-1">
        {CAPACIDADES.map((c) => (
          <button
            key={c.titulo}
            type="button"
            className="w-full rounded-lg border p-3 text-left transition-colors hover:bg-accent/40"
            onClick={() => onUsarExemplo(c.exemplo)}
          >
            <p className="font-medium text-sm">{c.titulo}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{c.descricao}</p>
            <p className="text-xs text-primary mt-1.5">"{c.exemplo}"</p>
          </button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

export default AjudaNorthIA;
